import { lightShadow } from '@/styles/shadow';

import { useColorTheme } from './useColor';

const useShadow = () => {
  const colorTheme = useColorTheme();
  return colorTheme === 'dark' ? lightShadow : lightShadow;
};

export default useShadow;
